import { render, staticRenderFns } from "./company-settings.vue?vue&type=template&id=15a03b24&scoped=true&"
import script from "./company-settings.vue?vue&type=script&lang=ts&"
export * from "./company-settings.vue?vue&type=script&lang=ts&"
import style0 from "./company-settings.vue?vue&type=style&index=0&id=15a03b24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a03b24",
  null
  
)

export default component.exports